import React, { useEffect, useState } from "react";
import ConfigTable from "./ConfigTable";
import { useSelector } from "react-redux";
import { selectBuilding, selectUserData } from "../../features/store";
import { TopNavBar } from "../../components/TopNavBar";
import { RectBtn } from "../../components/General";
import { IoIosAddCircleOutline, IoIosBuild } from "react-icons/io";
import AddConfig from "./AddConfig";
import DeleteConfig from "./DeleteConfig";
import ConfigThreshold from "./ConfigThreshold";
import { PERMISSION } from "../../configs/global";
import { ListItemIcon, Menu, MenuItem, Tab, Tabs, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FaShieldDog } from "react-icons/fa6";
import { FaRestroom } from "react-icons/fa";
import { BsFillBuildingFill } from "react-icons/bs";
import AddBuilding from "./AddBuilding";
import AddNano from "./AddNano";
const Config = () => {
    const buildings = useSelector(selectBuilding);
    const userData = useSelector(selectUserData);
    const [selectedBuilding, setSelectedBuilding] = useState(() => {
        return localStorage.getItem("selectedBuilding") || "all";
    });
    const navigate = useNavigate();
    const [buildingsWithAll, setBuildingWithAll] = useState({
        all: {
            buildingId: "all",
            buildingName: "All",
        },
    });
    const [duplicateConfig, setDuplicateConfig] = useState(null);
    const [openAddConfig, setOpenAddConfig] = useState(false);
    const [openAddBuilding, setOpenAddBuilding] = useState(false);
    const [openAddNano, setOpenAddNano] = useState(false);
    const [openThresholdConfig, setOpenThresholdConfig] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    useEffect(() => {
        if (
            userData.permission !== PERMISSION.SUPER &&
            userData.permission !== PERMISSION.ADMIN &&
            userData.permission !== PERMISSION.MANAGER
        ) {
            alert("Access denied. Please contact supervisor for permission.");
            navigate("/dashboard");
            return;
        }
    }, []);
    useEffect(() => {
        let all = {
            buildingId: "all",
            buildingName: "All",
        };
        setBuildingWithAll({ all, ...buildings });
        // if selected building is deleted, change selected building back to all
        if (!buildings[selectedBuilding]) {
            setSelectedBuilding("all");
        }
    }, [buildings]);
    return (
        <div className="config">
            <TopNavBar
                buildingDict={buildingsWithAll}
                selectedBuilding={selectedBuilding}
                setSelectedBuilding={setSelectedBuilding}
            ></TopNavBar>

            <div className="config-content">
                <div className="config-header-row">
                    <h3 className="config-title"> Configuration</h3>
                    <Tooltip
                        title={
                            userData.permission !== PERMISSION.ADMIN && userData.permission !== PERMISSION.SUPER
                                ? "You do not have permission to add configuration"
                                : ""
                        }
                        arrow
                        sx={{
                            maxWidth: 10,
                        }}
                    >
                        <div className="add-config-btn-wrapper">
                            <RectBtn
                                onClick={(e) => {
                                    setOpenThresholdConfig(true);
                                }}
                                disable={
                                    userData.permission !== PERMISSION.ADMIN && userData.permission !== PERMISSION.SUPER
                                }
                            >
                                <div className="add-config-btn-row">
                                    <IoIosBuild className="icon" />
                                    <p>Threshold Configs</p>
                                </div>
                            </RectBtn>
                        </div>
                    </Tooltip>
                    <Tooltip
                        title={
                            userData.permission !== PERMISSION.ADMIN && userData.permission !== PERMISSION.SUPER
                                ? "You do not have permission to add configuration"
                                : ""
                        }
                        arrow
                        sx={{
                            maxWidth: 10,
                        }}
                    >
                        <div className="add-config-btn-wrapper">
                            <RectBtn
                                onClick={(e) => {
                                    setAnchorEl(e.currentTarget);
                                }}
                                disable={
                                    userData.permission !== PERMISSION.ADMIN && userData.permission !== PERMISSION.SUPER
                                }
                            >
                                <div className="add-config-btn-row">
                                    <IoIosAddCircleOutline className="icon" />
                                    <p>New Config</p>
                                </div>
                            </RectBtn>
                        </div>
                    </Tooltip>
                </div>

                <ConfigTable
                    currBuilding={buildingsWithAll[selectedBuilding]}
                    setOpenAddConfig={setOpenAddConfig}
                    setDuplicateConfig={setDuplicateConfig}
                />
            </div>

            <div className="hidden-panels">
                <AddConfig
                    openAddConfig={openAddConfig}
                    setOpenAddConfig={setOpenAddConfig}
                    duplicateConfig={duplicateConfig}
                    setDuplicateConfig={setDuplicateConfig}
                />
                <AddBuilding openAddBuilding={openAddBuilding} setOpenAddBuilding={setOpenAddBuilding} />
                <AddNano openAddNano={openAddNano} setOpenAddNano={setOpenAddNano} />
                <ConfigThreshold switchOn={openThresholdConfig} setSwitchOn={setOpenThresholdConfig} />
            </div>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={() => {
                    setAnchorEl(null);
                }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <div className="new-config-menu-container">
                    <div
                        className="menu-item"
                        onClick={() => {
                            setOpenAddConfig(true);
                            setAnchorEl(null);
                        }}
                    >
                        <FaRestroom className="new-config-menu-icon recommend" />

                        <p className="new-config-menu-text recommend">Room</p>
                        <p className="hint">
                            A comprehensive process to configure building, room, sensors, and other devices.
                        </p>
                    </div>
                    <div className="new-config-menu-div-line"></div>
                    <MenuItem
                        onClick={() => {
                            setOpenAddBuilding(true);
                            setAnchorEl(null);
                        }}
                    >
                        <ListItemIcon>
                            <BsFillBuildingFill className="new-config-menu-icon" />
                        </ListItemIcon>
                        <p className="new-config-menu-text">Building</p>
                    </MenuItem>

                    <MenuItem
                        onClick={() => {
                            setOpenAddNano(true);
                            setAnchorEl(null);
                        }}
                    >
                        <ListItemIcon>
                            <FaShieldDog className="new-config-menu-icon" />
                        </ListItemIcon>
                        <p className="new-config-menu-text">Nano</p>
                    </MenuItem>
                </div>
            </Menu>
        </div>
    );
};

export default Config;
